export const ID_PAGE_MAIN_ELEMENT = 'page-main-element'
